import { Tooltip } from "@/components/ui/tooltip";
import useNumberFormatter from "@/hooks/useNumberFormatter";
import { Badge } from "@chakra-ui/react";
import { formatCalendarDate, formatMonth } from "../columns";
import { Contract } from "../types";

type Props = { contract: Contract };

const PendingChangeBadges = ({ contract }: Props): JSX.Element => {
  const formatCurrency = useNumberFormatter("es-CO", "COP", "currency");
  const { renewal, retirement } = contract.pendingChanges ?? {};

  return (
    <>
      {renewal && (
        <Tooltip
          content={`Desde ${formatMonth(
            renewal.effectiveMonth
          )}: canon ${formatCurrency(
            renewal.monthlyRent
          )}, fin ${formatCalendarDate(renewal.rentalsContractEndDate)}`}
        >
          <Badge bg="#DFEAFF" color="#6887D8" size="md">
            Renovación programada
          </Badge>
        </Tooltip>
      )}
      {retirement && (
        <Tooltip
          content={`Sale de la fianza en ${formatMonth(
            retirement.effectiveMonth
          )}`}
        >
          <Badge bg="#FFDCDC" color="#EC5858" size="md">
            Retiro en trámite
          </Badge>
        </Tooltip>
      )}
    </>
  );
};

export default PendingChangeBadges;
